import { z } from 'zod';

import { SortOrderSchema } from '@jane/bloom/types/schemas/algolia/review';

export const UpvotePayloadSchema = z.object({
  page: z.coerce.number(),
  productId: z.coerce.number(),
  reviewId: z.string(),
  sortOrder: SortOrderSchema,
});
export type UpvotePayload = z.infer<typeof UpvotePayloadSchema>;

export enum ReviewIntent {
  Report = 'report',
  Upvote = 'upvote',
}
